import { render, staticRenderFns } from "./BorderAnimationCard.vue?vue&type=template&id=99d59ba6&scoped=true&"
import script from "./BorderAnimationCard.vue?vue&type=script&lang=js&"
export * from "./BorderAnimationCard.vue?vue&type=script&lang=js&"
import style0 from "./BorderAnimationCard.vue?vue&type=style&index=0&id=99d59ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d59ba6",
  null
  
)

export default component.exports